import { DomainCreationCanActivateGuard } from '@app/core/guards/domain-creation.can-activate.guard';
import { DomainComponent } from './domain/domain.component';
import { SignupComponent } from './signup.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { SignupGuardCanActivateGuard } from '@app/core/guards/signup-guard.can-activate.guard';
import { SignupFormGuard } from '@app/core/guards/signup-form.guard';


export const SIGNUP_ROUTES = [
    {
        path: '',
        component: SignupComponent,
        canActivateChild: [SignupGuardCanActivateGuard],
        children: [
            {
                path: 'domain',
                component: DomainComponent,
                canActivate: [DomainCreationCanActivateGuard]
            },
            {
                path: 'plan/:id',
                component: SubscriptionComponent,
                canActivate: [SignupFormGuard]
            }
        ]
    },
];
